import * as React from 'react'
import { Modal, Button, message, Input } from 'antd'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { CreateSecurityRole, SecurityRole } from '@getgreenline/homi-shared'
import { parseErrorMsg } from '../../../../utilities/helpers'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  securityRole?: SecurityRole
  onClose: () => void
  onSubmit: () => void
}

interface State {
  isSaving?: boolean
  editSecurityRole: CreateSecurityRole
}

@inject('currentCompanyStore')
@observer
export class CreateSecurityRoleModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    const { securityRole } = this.props
    this.state = {
      isSaving: false,
      editSecurityRole: { ...new CreateSecurityRole(), ...securityRole },
    }
  }

  async save() {
    try {
      const { securityRole } = this.props
      this.setState({ isSaving: true })

      if (securityRole) {
        // Updating an existing security role
        const { editSecurityRole } = this.state
        const updateSecurityRole = Object.assign({ id: securityRole.id }, editSecurityRole)
        await this.props.currentCompanyStore!.updateSecurityRole(updateSecurityRole)
      } else {
        // Creating a new security role
        const { editSecurityRole } = this.state
        editSecurityRole.permissions = []
        this.props.currentCompanyStore!.addSecurityRole(editSecurityRole)
      }
    } catch (error) {
      message.error(parseErrorMsg(error) || 'There was an error creating this security role.')
      this.setState({ isSaving: false })
    } finally {
      message.success('Updated security role')
      this.props.onSubmit()
    }
  }

  render() {
    const { securityRole } = this.props
    const { editSecurityRole } = this.state

    return (
      <Modal
        title={securityRole ? 'Edit security role' : 'Add security role'}
        visible={true}
        onCancel={this.props.onClose}
        footer={[
          <Button key='cancel' onClick={this.props.onClose}>
            Cancel
          </Button>,
          <Button
            key='save'
            type='primary'
            disabled={!editSecurityRole.name}
            loading={this.state.isSaving}
            onClick={() => this.save()}
          >
            Save
          </Button>,
        ]}
      >
        <form>
          <div className='form-group'>
            <label className='form-label'>Name</label>
            <Input
              value={editSecurityRole.name || ''}
              onChange={(e) => {
                editSecurityRole.name = e.target.value
                this.setState({ editSecurityRole })
              }}
            />
          </div>

          <div className='form-group'>
            <label className='form-label'>Description</label>
            <Input
              value={editSecurityRole.description || ''}
              onChange={(e) => {
                editSecurityRole.description = e.target.value
                this.setState({ editSecurityRole })
              }}
            />
          </div>
        </form>
      </Modal>
    )
  }
}
